import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useBrand } from '../brand/BrandProvider';
import { createAppTheme } from '../theme';

const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { brand } = useBrand();
  const theme = useMemo(() => createAppTheme(brand), [brand]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default AppThemeProvider;
